module.exports = __webpack_public_path__ + "img/99.a1db24e7.png";